import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MODAL from '../../components/modal/modal';
import { toast } from 'react-toastify';

const EDIT_MODEL_MODAL = ({ isOpen, onClose, model, getUserModels }) => {
  const [inputValue, setInputValue] = useState({
    name: "",
    status: "not-started",
    list: "",
    points: 0
  });

  useEffect(() => {
    if (model) {
      setInputValue({
        name: model.name || "",
        status: model.status || "not-started",
        list: model.list ? (model.list.name || model.list) : "",
        points: model.points || 0
      });
    }
  }, [model]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value
    });
  };

  const handleSuccess = (message) => toast.success(message, { position: "top-right" });
  const handleError = (error) => toast.error(error, { position: "top-right" });

  const handleEditModelSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/models/edit-one-model`,
        {
          id: model._id,
          name: inputValue.name,
          status: inputValue.status,
          list: inputValue.list,
          points: inputValue.points
        },
        { withCredentials: true }
      );
      if (data.success) {
        handleSuccess(data.message);
        if (getUserModels) {
          getUserModels();
        }
        setTimeout(() => {
          toast('Model updated successfully', { position: 'bottom-left' });
          onClose();
        }, 500);
      } else {
        handleError(data.message || "Failed to edit model");
      }
    } catch (error) {
      console.error(error);
      handleError("An error occurred while updating the model.");
    }
  };

  return (
    <MODAL hasCloseBtn={true} isOpen={isOpen} onClose={onClose}>
      <h3>Edit Model</h3>
      <form onSubmit={handleEditModelSubmit} className="add-model-form" style={{ maxWidth: '100%', marginTop: '1rem' }}>
        <div className="form__group">
          <label htmlFor="edit-model-name" style={{display: 'none'}}>Name</label>
          <input
            type="text"
            id="edit-model-name"
            name="name"
            value={inputValue.name}
            onChange={handleOnChange}
            className="pill-input"
            required
            placeholder="Model Name"
          />
        </div>
        <div className="form__group">
          <label htmlFor="edit-model-list" style={{display: 'none'}}>List</label>
          <input
            type="text"
            id="edit-model-list"
            name="list"
            value={inputValue.list}
            onChange={handleOnChange}
            className="pill-input"
            required
            placeholder="List Name"
          />
        </div>
        <div className="form__group">
          <label htmlFor="edit-model-status" style={{display: 'none'}}>Status</label>
          <select 
            name="status" 
            id="edit-model-status" 
            value={inputValue.status} 
            onChange={handleOnChange}
            className="pill-input"
          >
            <option value="not-started">Status: Owned But Not Built</option>
            <option value="in-progress">Status: Built But Unpainted</option>
            <option value="complete">Status: Complete</option>
            <option value="not-owned">Status: Not Owned</option>
          </select>
        </div>
        <div className="form__group">
          <label htmlFor="edit-model-points" style={{display: 'none'}}>Points</label>
          <input
            type="number"
            id="edit-model-points"
            name="points"
            value={inputValue.points}
            onChange={handleOnChange}
            className="pill-input"
            min="0"
            placeholder="Points"
          />
        </div>
        <div className="form__group" style={{ marginTop: '1rem' }}>
          <button type="submit" className="btn-solid-gray pill" style={{ width: '100%' }}>Save Changes</button>
        </div>
      </form>
    </MODAL>
  );
};

export default EDIT_MODEL_MODAL;
